import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[story]'
})
export class StoryDirective {

    constructor(private el: ElementRef) { }

    @Input('story') storyNumber: string;

    @HostListener('mousedown') onMouseDown() {
        window.open(`https://dev.azure.com/vs-research/Research/_workitems/edit/${this.storyNumber.toUpperCase()}`, '_new');
    }
}
